export const ANDROID_CLOSE_DEEPLINK = 'dddriver://delivery-issues/completed'
export const IOS_CLOSE_DEEPLINK =
  'comdoordashdriver://delivery-issues/completed'

export enum DeactivationPolicyUrlsByCountry {
  AU = 'https://help.doordash.com/dashers/s/deactivation-policy-au',
  CA = 'https://help.doordash.com/dashers/s/deactivation-policy-ca',
  US = 'https://help.doordash.com/dashers/s/deactivation-policy-us',
}
export const CRITICAL_DELIVERY_ISSUES_FAQ_URL =
  'https://help.doordash.com/dashers/s/article/customer-reported-order-never-arrived-faq'
export const CUSTOMER_IS_UNAVAILABLE_FAQ_URL =
  'https://help.doordash.com/dashers/s/article/How-to-complete-a-delivery-when-the-customer-is-unavailable'
export const IC_AGREEMENT_URL =
  'https://help.doordash.com/dashers/s/ica-us?language=en_US'
export const EXTREME_LATENESS_FAQ_URL =
  'https://help.doordash.com/dashers/s/article/Lateness-Based-Deactivations-Explained?language=en_US'
